// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //apiURL: "http://127.0.0.1:3000"
  //apiURL: "http://localhost:3000"
  //apiURL: "http://192.168.42.19:3001"
  apiURL: "https://qaapi.sasadoctor.com"
  //apiURL: "https://api.sasadoctor.com"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts